export default "__VITE_ASSET__CdGiLMXy__"